var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.453,
    height: 20.959,
    viewBox: "0 0 21.453 20.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(-547.21 -269.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M556.763,310.222a9.311,9.311,0,0,1-8.6-5.426,8.973,8.973,0,0,1-.839-5.5,9.487,9.487,0,0,1,3.914-6.474,9.125,9.125,0,0,1,4.767-1.743c.355-.027.439.111.449.445.089,2.893.181,5.786.313,8.677a2.717,2.717,0,0,0,.413,1.138c.988,1.742,2,3.468,3.008,5.2q.609,1.049,1.217,2.1c.117.2.106.366-.122.472a13.258,13.258,0,0,1-1.272.573A8.292,8.292,0,0,1,556.763,310.222Z",
    transform: "translate(0 -19.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M672.313,274.6c0-1.626.009-3.252-.007-4.878,0-.36.133-.453.464-.424a11.164,11.164,0,0,1,8.241,4.328,10.613,10.613,0,0,1,2.221,5.289c.053.437.111.874.169,1.31.039.3-.071.419-.39.4q-2.084-.1-4.17-.17c-1.941-.068-3.882-.138-5.824-.178-.392-.008-.555-.166-.593-.517a5.029,5.029,0,0,1-.033-.535q0-2.315,0-4.629Zm1.151.195h.074c0,1.282.007,2.565,0,3.847,0,.369.152.536.512.537.138,0,.275.018.413.022,2.426.064,4.852.123,7.279.193.32.009.367-.14.341-.409a8.722,8.722,0,0,0-.918-2.971,9.881,9.881,0,0,0-3.875-4.22,7.71,7.71,0,0,0-3.273-1.151c-.556-.054-.55-.093-.55.47Q673.466,272.955,673.464,274.8Z",
    transform: "translate(-114.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M685.27,413.8c.762,0,1.461-.006,2.16,0q2.748.029,5.5.067c.585.007.612.009.563.608a8.874,8.874,0,0,1-3.574,6.594c-.225.173-.386.166-.554-.124-1.305-2.254-2.63-4.5-3.944-6.746A2.509,2.509,0,0,1,685.27,413.8Z",
    transform: "translate(-126.637 -132.549)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.b42bfc07a3505ec3a7d04ab1af4699ba.svg";
export { ForwardRef as ReactComponent };